<template lang="pug">
  div.home
    h1 Embedded, No Waiters
    p This screen assumes your system has all information from another page.
    p It is the simplest integration mode, with no programatic waiters.
    swbc-sales-frame.frame(mode="selection" :quote="quoteRequest" :book-immediately="true")
</template>

<script>
  import { mapGetters } from 'vuex'
  import SwbcSalesFrame from '@/components/SwbcSalesFrame'
  export default {
    name: 'EmbeddedNoWaiters',
    components: {
      SwbcSalesFrame
    },
    computed: {
      ...mapGetters(['quoteRequest'])
    }
  }
</script>

<style lang="sass">
  .frame
    border: none
    height: 700px
    width: 800px
</style>
